module.exports = __webpack_public_path__ + "img/148.880f65e8.jpg";